import React,{useEffect} from 'react'
import { Link } from 'react-router-dom'
import Header from'../Component/Header'
import Footer from'../Component/Footer'
const SchoolTransportation = () => {
      useEffect(() => {
        document.title = 'School Transportation -  St Peters convent School Faridabad Haryana';  
    }, []); 
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
     <li><Link to="/"> Home</Link> </li> 
<li>  Academics  </li> 
     <li>School Transportation </li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1>School Transportation  </h1>
         </div>
     </div>
     <div className="row">
       <div className="col-lg-12">
              <p>Bus facility has been provided for the convenience of parents and students, who are requested to follow the regulations stipulated below.</p>
              <ul className="list">
              <li>No child will be permitted to discontinue bus service in the middle of the year .</li>
              <li>All bus commuters are expected to be at the bus stop at least five minutes before the arrival of the bus.</li>
              <li>The bus will not wait for late comers.</li>
              <li>Children should stay away from the main road until the bus arrives.</li>
              <li>No student should come near the entry door of the bus until it has made a complete stop.</li>
              <li>The front door of the bus is the only authorized entrance and exit.</li>
              <li>The list of stops is prepared keeping in view for the convenience and safety of all bus commuters and it is always subject to change.</li>
              <li>When the bus is in motion students must not move in the bus not expose their heads or arms outside the window.</li>
              <li>No student is allowed to eat in the bus and should not throw anything inside or outside the bus.</li>
              <li>Shouting is prohibited in the bus. Courteous behavior is expected at all times.</li>
              <li>In case of any seat/seat cover etc. is torn or damaged, the cost will be recovered from the defaulter.</li>
              <li>The teachers and bus monitors are responsible for maintaining discipline in the buses. Any serious offence must be reported to the Principal.</li>
              <li>Students must travel only by the buses allotted to them.</li>
              <li>English speaking is necessary in the bus and at the bus stops. </li>
              <li>The driver’s attention must not be distracted for any reason.</li> 
              </ul> 
       </div>
     </div>
  </div>
</div>
<Footer/>
    </>
  )
}

export default SchoolTransportation
